import React from 'react'
import styled from 'styled-components'
import translate from '../../../../modules/translate'
import webLinks from '../../../../config/data/webLinks.json'
import moment from 'moment'
import Text from '../../../../components/Text'
import Link from '../../../../components/Link'
import loadable from '@loadable/component'
import PrivacyManager from '../../../../vendor/Sourcepoint/components/PrivacyManager'

const Iubenda = loadable(() => import('../../../../vendor/Iubenda'), { ssr: false })

const Wrapper = styled.div`
  flex: 4;
  justify-content: center;
  align-items: center;
  text-align: left;
  padding-top: ${(props) => props.theme.sizes.gapVertical};
  @media (max-width: 450px) {
    padding-right: ${(props) => props.theme.sizes.gapEdge};
    padding-left: ${(props) => props.theme.sizes.gapEdge};
  }
`

const StyledText = styled(Text)`
  color: ${(props) => props.theme.color.textSecondary};
`

const FirstWebLinksWrapper = styled.div``

const SecondWebLinksWrapper = styled.div`
  margin-top: ${(props) => props.theme.sizes.gapVertical};
`

const ThirdWebLinksWrapper = styled.div`
  margin-top: ${(props) => props.theme.sizes.gapVertical};
`

const FourthWebLinksWrapper = styled.div`
  margin-top: ${(props) => props.theme.sizes.gapVertical};
`

const StyledLink = styled(Link)`
  color: ${(props) => props.theme.color.textSecondary};
`

const WebLinks = ({ ...props }) => (
  <Wrapper {...props}>
    <StyledText>{translate('weblinks').toUpperCase()}:</StyledText>
    <FirstWebLinksWrapper>
      <StyledText>
        {webLinks.firstLine.map((link, index) => {
          return (
            <StyledLink key={index + 'weblink'} to={link.value}>
              {link.label} {index !== webLinks.firstLine.length - 1 ? '| ' : ' '}
            </StyledLink>
          )
        })}
      </StyledText>
    </FirstWebLinksWrapper>
    <SecondWebLinksWrapper>
      <StyledText>
        {webLinks.secondLine.map((link, index) => {
          return (
            <StyledLink key={index + 'weblink'} to={link.value}>
              {link.label} {index !== webLinks.secondLine.length - 1 ? '| ' : ' '}
            </StyledLink>
          )
        })}
      </StyledText>
    </SecondWebLinksWrapper>
    <ThirdWebLinksWrapper>
      <StyledText>
        {webLinks.thirdLine.map((link, index) => {
          return (
            <StyledLink key={index + 'weblink'} to={link.value}>
              {link.label} {index !== webLinks.thirdLine.length - 1 ? '| ' : ' '}
            </StyledLink>
          )
        })}
        <Iubenda />
        <PrivacyManager />
      </StyledText>
    </ThirdWebLinksWrapper>
    <FourthWebLinksWrapper>
      <StyledText>
        © {moment().format('YYYY')} Südtirol Online - {translate('vat')}: IT 00853870210
      </StyledText>
    </FourthWebLinksWrapper>
  </Wrapper>
)

export default WebLinks
